import {
  logout
} from "./chunk-RIHYP73M.mjs";

// src/hooks/wbk/auth/logout.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useLogout = (props) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.setQueryData(["user", props], null);
    }
  });
};

export {
  useLogout
};
//# sourceMappingURL=chunk-5BKUZGK5.mjs.map